import Cookies from 'js-cookie';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';


const WelcomeToMooimom = () => {
  const viewport = Cookies.get('viewport');
  const router = useRouter();

  return (
    <>
      <div className="md:hidden">
        <div className="bg-gradient-to-b from-[#7EDDD0] to-[#38c9bd] h-20 flex justify-center items-center">
          <Link href="https://www.mooimom.id?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_logo">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/logo_w.png"}
              alt="MOOIMOM logo"
              quality={100}
              width={500}
              height={80}
              className="w-[200px]"
            />
          </Link>
        </div>
      </div>
      <div className="container hidden my-6 md:block">
        <Link href="https://www.mooimom.id?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_logo">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/logo2.png"}
            alt="MOOIMOM logo"
            quality={100}
            width={500}
            height={80}
            className="w-[200px]"
          />
        </Link>
      </div>
      <div className="py-8 bg-welcomeMooimomBg">
        <div className={`${viewport === "desktop" ? "container" : ""} grid grid-cols-1 gap-5 md:grid-cols-2`}>
          <div className={`${viewport === "desktop" ? "" : "container"} order-1`}>
            <div>
              <Link href="https://www.mooimom.id/?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=disc70">
                <div className="md:hidden">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-disc-70-mb.jpg"}
                    alt="2022 discount image"
                    quality={100}
                    width={2167}
                    height={1251}
                    className="w-full rounded-3xl"
                  />
                </div>
                <div className="hidden md:block">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-disc-70-pc.jpg"}
                    alt="2022 discount image"
                    quality={100}
                    width={2584}
                    height={1250}
                    className="w-full rounded-3xl"
                  />
                </div>
              </Link>
            </div>
          </div>
          <div className={`${viewport === "desktop" ? "" : "container"} order-2 md:order-3`}>
            <div>
              <Link href="https://www.mooimom.id/login?sbind=dmNORVdFTENPTUU3NQ==&utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=voucher100&redirect=/user-voucher">
                <div className="md:hidden">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-voucher75rb-mb.jpg"}
                    alt="discount image"
                    quality={100}
                    width={1084}
                    height={626}
                    className="w-full rounded-3xl"
                  />
                </div>
                <div className="hidden md:block">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-voucher75rb-pc.jpg"}
                    alt="discount image"
                    quality={100}
                    width={1292}
                    height={625}
                    className="w-full rounded-3xl"
                  />
                </div>
              </Link>
            </div>
          </div>
          <div className="order-3 md:order-2 md:row-span-3">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-mom-image-mb.jpg"}
                alt="mom image"
                quality={100}
                width={570}
                height={539}
                className="w-full"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-mom-image-pc.jpg"}
                alt="mom image"
                quality={100}
                width={737}
                height={915}
                className="w-full"
              />
            </div>
          </div>
          <div className={`${viewport === "desktop" ? "" : "container"} order-4 md:col-span-2`}>
            <div className="px-10 -mt-20 bg-white md:-mt-32 rounded-3xl py-7">
              <Link href="https://www.mooimom.id/?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=get_promo">
                <div className="w-full md:grid md:grid-cols-3 md:gap-8 md:items-center">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-free-ongkir.png"}
                  alt="free shipping image"
                  quality={100}
                  width={380}
                  height={120}
                  className="w-full"
                />
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-flash-sale-2.png"}
                  alt="flash sale image"
                  quality={100}
                  width={400}
                  height={120}
                  className="w-full"
                />
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-original-product.png"}
                  alt="original product image"
                  quality={100}
                  width={450}
                  height={120}
                  className="w-full"
                />
                </div>
              </Link>
            </div>
            <div className="flex justify-center -mt-5">
              <button
                className="px-4 py-2 text-base text-white bg-mooimom rounded-3xl font-poppins"
                onClick={() => router.push("https://www.mooimom.id/?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=get_promo")}
              >
                Ambil Promonya
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container grid grid-cols-1 gap-8 my-6 md:grid-cols-2">
        <div className="col-span-1 md:col-span-2">
          <Link href="https://www.mooimom.id/?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=disc70">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-free-goodies-mb-new.jpg"}
                alt="free goodies image"
                quality={100}
                width={520}
                height={200}
                className="w-full rounded-3xl"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-free-goodies-pc-new.jpg"}
                alt="free goodies image"
                quality={100}
                width={1280}
                height={200}
                className="w-full rounded-3xl"
              />
            </div>
          </Link>
        </div>
        <div className="col-span-1">
          <Link href="https://www.mooimom.id/product/mooimom-pocket-sling?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=pocket_sling">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-pocket-hipseat.jpg"}
              alt="hipseat image"
              quality={100}
              width={620}
              height={300}
              className="w-full rounded-3xl"
            />
          </Link>
        </div>
        <div className="col-span-1">
          <Link href="https://www.mooimom.id/product-category/nero-bianco-clothing-series?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=nero_bianco">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-nero-mb-new.jpg"}
              alt="clothing series image"
              quality={100}
              width={620}
              height={300}
              className="w-full rounded-3xl md:aspect-[31/15] md:object-cover"
            />
          </Link>
        </div>
        <h3 className="col-span-1 text-3xl font-medium text-center text-block font-poppins md:col-span-2">Paling Dicari</h3>
        <div className="col-span-1">
          <Link href="https://www.mooimom.id/product/new-bamboo-postpartum-belly-band-korset-pelangsing-pasca-melahirkan?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=bamboo_corset">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-bamboo-corset-mb-new.jpg"}
                alt="bamboo corset image"
                quality={100}
                width={1084}
                height={417}
                className="w-full rounded-3xl"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-bamboo-corset-pc-new.jpg"}
                alt="bamboo corset image"
                quality={100}
                width={1293}
                height={417}
                className="w-full rounded-3xl"
              />
            </div>
          </Link>
        </div>
        <div className="col-span-1">
          <Link href="https://www.mooimom.id/product/new-bamboo-postpartum-belly-band-korset-pelangsing-pasca-melahirkan?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=bamboo_corset">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-pompa-asi-mb-new.jpg"}
                alt="pompa asi image"
                quality={100}
                width={1084}
                height={418}
                className="w-full rounded-3xl"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-pompa-asi-pc-new.jpg"}
                alt="pompa asi image"
                quality={100}
                width={1293}
                height={418}
                className="w-full rounded-3xl"
              />
            </div>
          </Link>
        </div>
        <div className="col-span-1 md:col-span-2">
          <Link href="https://www.mooimom.id/user-referral?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=refer_a_friend">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-referral-mb.jpg"}
                alt="share image"
                quality={100}
                width={1084}
                height={417}
                className="w-full rounded-3xl"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-referral-pc.jpg"}
                alt="share image"
                quality={100}
                width={2668}
                height={314}
                className="w-full rounded-3xl"
              />
            </div>
          </Link>
        </div>
        <div className="col-span-1 md:col-span-2">
          <Link href="https://api.whatsapp.com/send/?phone=6281288446533&text&type=phone_number&app_absent=0">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-wa-mb.jpg"}
                alt="whatsapp image"
                quality={100}
                width={1085}
                height={313}
                className="w-full rounded-3xl"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-wa-pc.jpg"}
                alt="whatsapp image"
                quality={100}
                width={2668}
                height={314}
                className="w-full rounded-3xl"
              />
            </div>
          </Link>
        </div>
        <div className="col-span-1 md:col-span-2">
          <Link href="https://www.mooimom.id/welcome-mooimom-mp?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mooimom&utm_content=official_mp">
            <div className="md:hidden">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-official-mp-mb.png"}
                alt="whatsapp image"
                quality={100}
                width={520}
                height={150}
                className="w-full rounded-3xl"
              />
            </div>
            <div className="hidden md:block">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/new2022-official-mp-pc.png"}
                alt="marketplace image"
                quality={100}
                width={1280}
                height={150}
                className="w-full rounded-3xl"
              />
            </div>
          </Link>
        </div>
      </div>
      <div className="container py-4">
        <h3 className="my-5 text-2xl font-medium text-center text-black font-poppins">Keep Engaged With Us</h3>
        <div className="bg-white rounded-3xl py-8 px-6 shadow-[0_1px_5px_0_#cecece] space-y-4 md:flex md:justify-between md:space-x-8 md:space-y-0">
          <button
            className="bg-mooimom rounded-lg h-[50px] w-full flex justify-center items-center text-black font-medium relative cursor-pointer"
            onClick={() => router.push("https://www.mooimom.id/mamapedia-homepage?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_mamapedia&utm_content=mamapedia")}
          >
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/mamapedia.png"}
              alt="Tips Kehamilan & Menyusui"
              quality={100}
              width={150}
              height={150}
              className="w-[30px] absolute left-6"
            />
            <p className="px-10 text-base">Tips Kehamilan & Menyusui</p>
          </button>
          <button
            className="bg-mooimom rounded-lg h-[50px] w-full flex justify-center items-center text-black font-medium relative cursor-pointer"
            onClick={() => router.push("https://www.mooimom.id/store-locations?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_store_location&utm_content=store_location")}
          >
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom-new/store-location.png"}
              alt="Store Location"
              quality={100}
              width={150}
              height={150}
              className="w-[30px] absolute left-6"
            />
            <p className="text-base">Store Location</p>
          </button>
        </div>
        <p className="my-8 text-xs text-center text-black font-poppins">Copyright © MOOIMOM CO., LTD. All Rights Reserved</p>
      </div>
    </>
  )
}

export default WelcomeToMooimom
